<template lang="pug">
  v-hover(v-slot:default="{ hover }")
    v-card.datacard.d-flex.flex-column(:to="to" :flat="flat" :outlined="outlined" :class="{'elevation-1': hover}")
      v-card-title(:class="{'py-0':dense}").d-block.pt-0
        .d-flex.align-center
          router-link.no-decoration(:to="{ name: 'collection', params: { id: collectionId } }" v-if="collectionId&&showCollection")
            .overline.grey--text.text--darken-2(v-line-clamp="1" style="font-size:55% !important") {{collectionTitle}}
          div(v-else)
            br
          v-spacer
          v-chip(label color="orange" dark small v-if="isProtected" style="margin-right:-12px")
            span.overline Internal Use
        .title {{title}}
      v-card-text.py-0(:style="dense ? '' : `height: ${descHeight}px`")
        span.description(v-if="!(hoverDetails && hover)" v-line-clamp="rows") {{description}}
        div(v-if="hoverDetails && hover")
          div(v-if="!s3Details")
            span.description(v-if="extUrl" v-line-clamp="rows") This resource has been identified as containing Arlington-specific information and a link to the dataset is provided. View external dataset for additional information.
            span.description(v-else v-line-clamp="rows") {{description}}
          div(v-if="s3Details") <strong>Last Updated:</strong> {{fromNow(s3Details.LastModified)}}
          div(v-if="s3Details") <strong>Download Size:</strong> {{filesizeString}}
          div(v-if="numberOfRecords") <strong>Number of Records:</strong> {{numberOfRecords ? numberOfRecords.toLocaleString() : '-'}}
          div.d-none.align-center(v-if="rows>=3")
            span <strong>Popularity:</strong>
            v-progress-linear(:value="description.length%100" height="10px").mx-2
      v-spacer
      v-card-text.pb-0(v-if="showDetails")
        div <strong>Last Updated:</strong> {{s3Details ? fromNow(s3Details.LastModified) : 'Unknown'}}
        div <strong>Number of Records:</strong> {{numberOfRecords ? numberOfRecords.toLocaleString() : '-'}}
        div.d-none.align-center
            span <strong>Popularity:</strong>
            v-progress-linear(:value="description.length%100" height="10px").mx-2
      v-card-actions(v-if="showNav")
        tooltip-btn(label="Details" icon="mdi-information-outline" :to="{name:'dataset',params:{id:datasetId},query:{tab:'2'}}")
        tooltip-btn(v-if="url" label="View Data Table" icon="mdi-table" :to="{name:'dataview',params:{datasetId:datasetId}}")
        tooltip-btn(v-if="url" label="View Raw Data" icon="mdi-code-json" :href="apiUrl" @click.stop)
        tooltip-btn(v-if="url" label="Copy API URL to clipboard" icon="mdi-clipboard-text-outline" v-clipboard="apiUrl" @click.prevent)
        tooltip-btn(v-if="extUrl" label="View External Dataset" icon="mdi-web" :href="extUrl" @click.stop target="_blank")
        tooltip-btn(v-if="download" label="Download Full Dataset" icon="mdi-download-outline" :href="downloadUrl" @click.stop)
      v-card-actions(v-if="showViewNav")
        tooltip-btn(label="View Raw Data" icon="mdi-code-json" :href="apiUrl" @click.stop)
        tooltip-btn(label="Copy API URL to clipboard" icon="mdi-clipboard-text-outline" v-clipboard="apiUrl" @click.prevent)
</template>

<script>
import moment from "moment";
import filesize from "filesize";
import TooltipBtn from "./TooltipBtn.vue";

export default {
  components: { TooltipBtn },
  props: {
    title: String,
    description: String,
    numberOfRecords: Number,
    s3Details: Object,
    url: String,
    extUrl: String,
    download: String,
    datasetId: String,
    collectionId: String,
    collectionTitle: String,
    to: Object,
    rows: String,
    hoverDetails: Boolean,
    showDetails: Boolean,
    showNav: Boolean,
    showViewNav: Boolean,
    flat: Boolean,
    outlined: Boolean,
    dense: Boolean,
    showCollection: Boolean,
    isProtected: Boolean,
    token: String
  },
  methods: {
    fromNow(lastUpdate) {
      return moment(lastUpdate).fromNow();
    }
  },
  computed: {
    downloadUrl() {
      return this.download + "?v=" + (this.s3Details ?  moment(this.s3Details.LastModified).unix() : moment().unix());
    },
    apiUrl() {
      let query = {}
      if (this.url.includes('datahub-v2-s3') || this.url.includes('download.data.arlingtonva.us'))
        query.v = (this.s3Details ?  moment(this.s3Details.LastModified).unix() : moment().unix());
      if (this.token)
        query.token = this.token

      if (Object.keys(query).length > 0)
        return `${this.url}?${Object.entries(query).map(([key, value]) => `${key}=${value}`).join('&')}`
      else
        return this.url
    },
    descHeight() {
      let result = 22 * parseInt(this.rows);
      if (!this.dense) result += 14;
      return result;
    },
    filesizeString() {
      return filesize(this.s3Details.ContentLength);
    }
  }
};
</script>

<style lang="stylus">
.datacard {
  .title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  .description {
    word-break: normal;
    line-height: 22px;
  }
}
</style>